/**
 * 接口域名的管理
 */
const base = {
  sq: 'https://hsadmin.fotile.com/',
    // sq: 'https://hscom.efotile.com/',
  // 线上
  // sq: "/"

  // 本地
  //  sq: '/api'
};

export default base;
